/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';

// context imports
import { AuthContext } from '../../contexts/AuthContext';
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import Footer from './Footer';
import Plant2 from '../../assets/plant2.jpg';
import RanjanaV from '../../assets/RanjanaV4.jpg';
import BhartiK from '../../assets/BhartiK.jpg';
import LookingToBecomeAProvider from '../../assets/lookingToBecomeAProvider.svg';
import GiftBackground from '../../assets/GiftBackground.svg'
import DownArrow from '../../assets/downArrow.svg';

// import './Home-old.css';

const Home = props => {

    // context
    const { isAuthenticated, setIsAuthenticated, user, setUser } = useContext(AuthContext);
    const { theme, fontFamily, colors } = useContext(ThemeContext);

    // states
    const [textStyle, setTextStyle] = useState(theme.homeTitle);
    const [showScrollDown, setShowScrollDown] = useState(true);

    const checkScrollDown = () => {
        let maxScroll = document.body.scrollHeight - window.innerHeight;
        if (!showScrollDown && window.pageYOffset < (maxScroll - 150)) {
            setShowScrollDown(true)
        } else if (showScrollDown && window.pageYOffset > (maxScroll - 150)) {
            setShowScrollDown(false)
        }
    };

    const scrollDown = () => {
        window.scrollTo({ top: window.pageYOffset + 250, behavior: 'smooth' });
    }

    window.addEventListener('scroll', checkScrollDown);

    const gotoGVPage = () => {
        try {
            if (window.confirm("By clicking on OK you will be redirected to RazorPay Payment page to buy GiftVoucher")) {
                window.location.href = "https://rzp.io/l/jkStIE8";
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General Home gotoGVPage', 'Error in try catch block', err.stack);
        }
    }

    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At General Home GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>
            <div id="hero-div" className="row" style={{ backgroundColor: "#fff" }}>
                <div className="col-md-6 col-6 my-auto py-4" >
                    <h1 className="Headline" style={textStyle}>Online counselling for every mind.<br />Talk to us and heal yourself.</h1>
                    <Link to="/client/booksession">
                        <button id="book-session-btn" className="btn HeadButton" style={theme.homeAction}>Book Session</button>
                    </Link>
                </div>
                <div className="col-md-4 col-6 ml-auto">
                    <img style={{ maxHeight: "40rem", width: "100%" }} src={Plant2} alt="home-image" />
                </div>
            </div>

            {
                showScrollDown ? <div className="downArrowDiv"><img id="scrolldown-div" className="downArrowImg" src={DownArrow} onClick={scrollDown} /></div> : null
            }

            {/* Gift Voucher */}
            <div id="gift-voucher-div" className="row" style={{ padding: "5px 0", height: "250px", backgroundImage: `url(${GiftBackground})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', borderTop: '1px solid rgb(56, 78, 11)' }}>
                <div className="col-12 text-center d-flex">
                    <button id="give-gift-voucher-btn" className="btn m-auto HeadButton giftVoucherBtn" style={theme.homeAction} onClick={gotoGVPage}>Give a GIFT of Wellness</button>
                </div>
            </div>

            {/* How it works */}
            <div id="how-it-works-div" className='row' style={{ backgroundColor: "#f7f6f9" }}>
                <h2 className="col-md-12 col-12 text-center mt-5" style={{ fontFamily: fontFamily.primary }} >How it works</h2>
                <div className="col-md-12 col-12 my-5" style={{ fontFamily: fontFamily.primary }}>
                    <div className="row px-3">
                        <span className="col-md-1 col-4 text-center my-auto homeHIWIcons">
                            <i className="fas fa-user-md"></i>
                        </span>
                        <div className="col-md-3 col-4 d-flex align-items-center" style={{ borderBottom: '2px solid #4F6A97' }}>
                            <p className="text-center" style={{ fontSize: '1rem' }}>Find a counsellor that you can trust.</p>
                        </div>
                        <span className="col-md-1 col-4 text-center my-auto homeHIWIcons">
                            <i className="fas fa-comments"></i>
                        </span>
                        <div className="col-md-3 col-4 d-flex align-items-center" style={{ borderBottom: '2px solid #4F6A97' }}>
                            <p className="text-center" style={{ fontSize: '1rem' }}>Consult using chat, phone, and video.</p>
                        </div>
                        <span className="col-md-1 col-4 text-center my-auto homeHIWIcons">
                            <i className="fas fa-smile-beam"></i>
                        </span>
                        <div className="col-md-3 col-4 d-flex align-items-center" style={{ borderBottom: '2px solid #4F6A97' }}>
                            <p className="text-center" style={{ fontSize: '1rem' }}>Gain your life back!</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Find a Provider */}
            <div id="find-provider-div" className="row" style={{ backgroundColor: "#D8ECEF" }}>
                <h2 className="col-md-12 col-12 text-center mt-5" style={{ fontFamily: fontFamily.primary }} >Professional Counsellors<br />that you can trust</h2>
                <div className="col-md-6 col-12 mt-3 text-center">
                    <img width="150px" height="150px" style={{ borderRadius: "100%", objectFit: "cover" }} src={RanjanaV} alt="Managing Founder" />
                </div>

                <div className="col-md-6 col-12 mt-3 text-center">
                    <img width="150px" height="150px" style={{ borderRadius: "100%", objectFit: "contain" }} src={BhartiK} alt="CEO" />
                </div>

                <div className="my-5 col-md-12 col-12 text-center">
                    <a href='/counsellors'>
                        <button id="find-provider-btn" className="btn m-0" style={theme.homeAction}>Find Counsellor</button>
                    </a>
                </div>
            </div>


            {/* Looking to become a Provider */}
            <div id="become-provider-div" className="row pt-5 pb-4" style={{ backgroundImage: `url(${LookingToBecomeAProvider})`, height: "300px", backgroundPosition: 'center', backgroundSize: 'cover' }}>
                <h2 className="col-md-12 col-12 text-center">Sign Up to become an Umang Wellness counsellor.</h2>
                <div className="col-md-12 col-12 text-center">
                    <Link to='/counsellorsignup'>
                        <button id="provider-signup-btn" className="btn m-0" style={theme.homeAction}>Sign Up Here</button>
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default Home;
